module.exports = __webpack_public_path__ + "static/media/confeitaria-duque-caxias-cardapio-menu-ingles-portugues.296682dd.jpg";